














import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Dialog = namespace('Dialog');

@Component
export default class DialogConnector extends Vue {
  @Dialog.State
  public dialogType!: string;

  @Dialog.State
  public open!: boolean;

  @Dialog.State
  public dialogData!: any;

  @Dialog.Action
  public updateDialog!: (payload: { open: boolean; dialogType: string; dialogData: {} }) => {}

  public openDialog(dialogType: string, dialogData: { [key: string]: any }) {
    this.updateDialog({ open: true, dialogType, dialogData });
  }

  public closeDialog() {
    this.updateDialog({ open: false, dialogType: '', dialogData: {} });
  }

  // eslint-disable-next-line class-methods-use-this
  get possibleDialog() {
    return [
      'LoginDialog',
      'RegisterDialog',
      'DepositDialog',
      'WithdrawDialog',
      'PromotionDialog',
      'ContactDialog',
      'FortuneWheelDialog',
      'SummaryDialog',
      'AffiliateDialog',
      'ProfileDialog',
      'RefundLossDialog',
      'ResetPasswordDialog',
      'AffiliateWithdrawDialog',
    ];
  }
}
